module.exports = __webpack_public_path__ + "static/mtsuka-5ed46fbe4945afaa09f1d8a2e2392a66.jpg";